<template>
  <div class="tabs my-2 ">
    <div class="tab-buttons">
        <div class="d-flex justify-content-between">
          <div class="p-2 d-flex flex-row">             
              <b-icon-plus-lg scale="1.2" class="cursorPoint plus mt-0 mr-1" @click="openModal()"></b-icon-plus-lg>&nbsp;
              <s-confirmation-button v-if="!isDeleteContactBtnHidden"  
                  ref="confirmBtn"
                  :showIconOnly=true
                  :messages="customMessages"
                  @confirmation-success="removeContact()"
                  :variant="getTheme.olight"
              >
                  <template v-slot:icon>
                      <b-icon-trash :variant="getTheme.danger" font-scale="1"></b-icon-trash>
                  </template>
              </s-confirmation-button>
          </div>
          <div class="p-2"> 
           
          </div>
          <div class="p-2 d-flex flex-row-reverse">
            
          </div>
        </div>
        <div class="d-flex justify-content-between">
          
        </div> 

        <b-modal scrollable centered 
            :id="modalClient" 
            :title="$t('c_SelectionContact')"
            :header-bg-variant="getTheme.dark"
            :header-text-variant="getTheme.light"
            :body-bg-variant="getTheme.light" 
            :footer-bg-variant="getTheme.light"
            :footer-text-variant="getTheme.light"
            @show="resetModal"
            @hidden="resetModal"
            @ok="handleOk"
        >
            <b-row>
                <b-col xs="12" sm="12" md="12" lg="12" :xl="12">
                    
                  <b-row class="addLicContainer mb-2">
                          <!--BOUTON POUR OUVRIR LE COMBO-->
                          <span class="btnContainer">
                              <b-button class="btnShow btnShowStateStd" @click="createNewContact()">{{$t('c_AjoutContact')}}</b-button>
                          </span>
                  </b-row>
                    <!--LIGNE DE RECHERCHE ITEM-->
                    <b-row class="addLicContainer">
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                                <b-form-input id="search" name="search" type="text" :placeholder="$t('g_Recherche')" v-model="txtRecherche"></b-form-input>

                            <b-input-group-append is-text class="cursorPoint" @click="txtRecherche = ''">
                                <b-icon icon="x"></b-icon>
                            </b-input-group-append>
                        </b-input-group>
                    </b-row>
                    <!--CONTENU-->
                    <div class="scroll borderMain">
                        <!--LIST DES ITEMS-->
                        <b-list-group style="margin-top: 5px">
                                <b-list-group-item 
                                    class="cursorPoint btnStyle" 
                                    v-for="(contact) in getFilteredContacts" :key="contact.id" 
                                    @click="handleSelected(contact.id)">
                                    
                                    <span>{{contact.name}}</span>
                                </b-list-group-item>
                        </b-list-group>

                    </div>
                </b-col>
            </b-row>
        </b-modal>

        <span v-for="(contact, index) in getContacts" :key="index">
              <b-button
                  :class="{ 'active': contactIndex == index, 'custom-button': true }"
                  @click="changeTab(index)"
              >
                  <div><span v-text="contact.name"></span></div>
              </b-button>
        </span>

        <template v-if="getCurrentContact">
          <s-input :disabled="!getCurrentContact.isActive" id = "name" name="name" type="text" maxlength="40" class="MargeTop15" :placeholder="$t('c_Nom')" v-capitalize v-model="getCurrentContact.name" :state="isValid(getCurrentContact.name)"></s-input>
          <s-input :disabled="!getCurrentContact.isActive" id = "title" name="title" type="text" maxlength="40" class="MargeTop15" :placeholder="$t('c_Titre')" v-capitalize v-model="getCurrentContact.title" :state="isValid(getCurrentContact.title)"></s-input>
          <s-input :disabled="!getCurrentContact.isActive" id = "add" name="add" type="text" maxlength="250" class="MargeTop15" :placeholder="$t('c_Adresse')" v-capitalize v-model="getCurrentContact.address1" :state="isValid(getCurrentContact.address1)"></s-input>
          <s-input :disabled="!getCurrentContact.isActive" id = "city" name="city" type="text" maxlength="40" class="MargeTop5" :placeholder="$t('c_Ville')" v-capitalize v-model="getCurrentContact.city" :state="isValid(getCurrentContact.city)"></s-input>
          <b-row>
              <b-col cols="5" xl="4">
                  <s-input :disabled="!getCurrentContact.isActive" id = "zipCode" name="zipCode" type="text" maxlength="7" class="MargeTop5" :placeholder="$t('c_CodePostal')" v-uppercase v-model="getCurrentContact.zipcode"></s-input>
              </b-col>
          </b-row>
          
          <b-row>
              <b-col cols="7" xl="4">
                  <s-input :disabled="!getCurrentContact.isActive" id = "tel" name="tel" type="text" maxlength="15" class="MargeTop15" :placeholder="$t('c_Telephone')" v-mask="'(999) 999 9999'" v-model="getCurrentContact.tel" :state="isValid(getCurrentContact.tel)"></s-input>
              </b-col>
              <b-col cols="4" xl="3">
                  <s-input :disabled="!getCurrentContact.isActive" id = "telExt" name="telExt" type="text" maxlength="10" class="MargeTop15" :placeholder="$t('c_Ext')" v-model="getCurrentContact.telExt"></s-input>
              </b-col>
          </b-row>
          <s-input :disabled="!getCurrentContact.isActive" id = "email" name="email" type="text" maxlength="40" class="MargeTop5" :placeholder="$t('c_Courriel')" v-model="getCurrentContact.email" :state="isValid(getCurrentContact.email)"></s-input>
          
          <b-button style="margin-top: 10px;" :disabled="!isContactChanged" v-show="getCurrentContact.isActive" :variant="getTheme.success" @click="saveContact()" >{{$t("g_Enregistrer")}}</b-button>
        </template>
        <template v-else-if="getContacts.length == 0">
          <span>{{ $t('c_NoContactFound')}}</span>
        </template>
      </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {dataService} from '@/services'

export default {
    name: "s-tabsContact",
    props : ['type','contactList'],
    data() {
      return {
        modalClient : null,
        customMessages: [
          '',
          'Etes-vous sûr?',
          '',
        ],
        txtRecherche : '',
        selectedContact: 0,
        parentId : 0,
        contactIndex : -1,
        currentId : 0,
        isAddContact : false,
        initialContact : {},
        originalContact : {},
        contacts : []
      };
    },
    methods: {
      isValid : (str) => (!(str === "undefined" || str?.length == 0)), //Valide si le champs n'est pas indefini ni vide
      openModal() {
        this.contactIndex  = -1
        this.currentId  = 0
        this.isAddContact = false;
        this.$bvModal.show(this.modalClient)
      },  
      resetModal() {
   
      },
      handleSelected(contactId) {
        this.selectedContact = contactId
        // Fermer le modal manuellement
        this.$nextTick(() => {
          this.$bvModal.hide(this.modalClient)
        })
      },
      handleOk(bvModalEvent) {
        bvModalEvent.preventDefault()

        // Fermer le modal manuellement
        this.$nextTick(() => {
          this.$bvModal.hide(this.modalClient)
        })
      },
      /**
       * Etablit le comportement par defaut après chaque action (ajout/modification/desactivation d'un contact)
       */
      resetfields() {
        //this.$refs.confirmBtn.init();
        this.isAddContact = false
        this.contactIndex = -1
        this.currentId = 0
        this.selectedContact = 0
        this.refreshContactList()
      },
      /**
       * Ajouter un nouveau contact
       */
      createNewContact() {
        this.$bvModal.hide(this.modalClient)
        this.isAddContact = true;
        this.contactIndex  = -1
        this.currentId  = 0
      },
      /**
       * Choisir le contact à afficher
       */
      changeTab(index) {
          this.contactIndex = (this.contactIndex == index) ? -1 : index //Si on choisit deux fois le meme contact, om cache les champs
          this.currentId = this.contactIndex != -1 ? this.getContacts[index].id : 0
          this.originalContact = this.contactIndex != -1 ? this.$CObj(this.getContacts[this.contactIndex]) : {}
      },
      /**
       * Supprimer (Désactiver) un contact
       */
      removeContact() {
        if(this.currentId > 0) {
          this.$emit('removeContact', {contactId: this.currentId}  ) 
        }
        this.resetfields()
      },
      /**
       * Enregistre / Modifier un contact
       */
      saveContact() {
        if(this.isAddContact) {
          this.$emit('saveNewContact', {newContact: this.getCurrentContact}  )  //On ajoute un nouveau contact en suite l'ajouter dans le client
        } 
        else {
          this.$emit('updateContact', {contact: this.getCurrentContact}  )  //On modifie le contact
        }
        this.resetfields()
      },

      async refreshContactList() {
        let contacts = []
        switch(this.type) {
          case "supplierContacts":
            contacts = await dataService.getContactsSupplier().then((response) => {
              this.initialContact = this.$CObj(response.data.addons.classes[0])
              return response.data.data
            });
            break;
          case "clientContacts":
            contacts = await dataService.getClientContacts().then((response) => {
              this.initialContact = this.$CObj(response.data.addons.classes[0])
              return response.data.data
            });
            break;

          default:
            contacts = await dataService.getClientContacts().then((response) => response.data.data)
        }
        this.contacts = contacts
      }
    },
    computed: {
      ...mapGetters(['getTheme','getAllData']),
      /**
       * Valider l'état des champs du contact
       */
      isContactChanged() {
        if(this.isAddContact) return true
        else return JSON.stringify(this.originalContact) != JSON.stringify(this.getCurrentContact)
      },
      /**
       * Si un contact actif est selectionné on retoourne vrai
       */
      isDeleteContactBtnHidden() {
       return this.currentId == 0
      },
      getFilteredContacts() {
        const searchString = this.txtRecherche.toLowerCase().trim();
        let filteredList = this.contacts.filter(contact => contact.name.toString().toLowerCase().indexOf(searchString) > -1)
        return filteredList
      },
      getCurrentContact() {
        if(this.contactIndex == -1 && this.isAddContact) {
          return this.initialContact
        }
        return this.getContacts[this.contactIndex]
      },

      /**
       * Filter la liste des contacts à afficher
       */
      getContacts() {
        let ids = []
        if(this._contactList?.length > 0) {
          ids = this._contactList.filter(obj => obj.contactId > 0).map(obj => obj.contactId);
        }
        var filtered = this.contacts.filter((cont) => ids.indexOf(cont.id) != -1)
        return filtered;
      },
      _contactList: {
            get: function() {
              this.refreshContactList()
              return this.contactList
            },
            set: function(modifiedValue){this.$emit('update:contactList', modifiedValue)}
        }
    },
    async mounted() {
      //Synchroniser la liste des contacts
      this.resetfields()

      //Les noms des modal doivent etre unique, sinon on pourrait avoir des superpositions de plusieurs modal 
      //lorsque ces modal sont appelés à plusieurs endroit
      this.modalClient = 'modalClient_'+this._uid
    },
    watch: {
      selectedContact(newValue) {
        this.resetfields()
        if(newValue > 0) {
          let contact = this.contacts.find(contact => typeof contact !== 'undefined' && contact.id == newValue);
          this.$emit('insertContact', {contact: contact} )
        }
      },
    },
};
</script>


<style lang="scss" scoped>
.borderMain{
    background: white;
    padding-left: 5px;
    border-left: 1px solid lightgray;
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
}

.btnStyle{
    border-radius: 5px;
    width: 98%;
    height: 40px;
    line-height: 40px;
    position: static;
    margin-bottom: 2px;
    text-align: left;
    border: 1px solid $btnBorder;
    background-image: linear-gradient(90deg, $cContainerLeftBorder 5px, $cContainerBackColor 5px);
    text-transform:lowercase;
    ::first-letter{
        text-transform: uppercase;
    }
}

.btnStyle:hover{
    background-image: linear-gradient(90deg, $cContainerLeftBorder 5px, $btnBackHover 5px);
}
.btnStyle:active{
    background-image: linear-gradient(90deg, $btnBackActive 5px, $cContainerLeftBorder 5px);
}
.btnStylSelected{
    border-radius: 5px;
    width: 98%;
    height: 40px;
    line-height: 40px;
    position: static;
    margin-bottom: 2px;
    text-align: left;
    border: 1px solid $btnBorder;
    background-image: linear-gradient(90deg, $btnBackActive 5px, $cContainerLeftBorder 5px);
    ::first-letter{
        text-transform: uppercase;
    }
    font-weight: bold;
}

span {
  display: inline-block;
  vertical-align: top;
  line-height: normal;
}

.addLicContainer{
    width: 100%;
    margin: 0px 0px 0px 0px;
}

.plus{
  color: green;
}
.moins{
  color: red;
}

.custom-button {
    height: 20px;
    border: none;
    border-radius: 5px;
    background-color: #ccc;
    color: #333;
    font-size: 12px;
    padding: 0px 12px;
    margin: 3px;
}

.custom-button2 {
    padding-top: 0px;
    padding-left: 5px;
    height: 20px;
    width: 20px;
    border: none;
    border-radius: 5px;
    background-color: #ccc;
    color: #333;
    font-size: 16px;
    margin-right: 5px;
}

.tabs {
  /* Styles pour les onglets */
}

.tab-buttons {
  /* Styles pour les boutons d'onglet */
}

.tab-buttons button {
  /* Styles pour chaque bouton d'onglet */
}

.tab-buttons button.active {
  /* Styles pour le bouton d'onglet actif */
}

.tab-content {
  /* Styles pour le contenu des onglets */
}

.tab-content div {
  /* Styles pour chaque contenu d'onglet */
}
</style>